import Button, { ButtonProps } from 'material-ui/Button/Button';

export { ButtonProps as IButtonProps };
export default Button;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Button/index.ts